module.exports = __webpack_public_path__ + "img/c-qdyy.4728e85a.png";